import Component from '../../../../../../../../lib/component';
import template from './calendar.small.html';
import './calendar.small.scss';
import SmallCalendarHeader from './calendar.small.header/calendar.small.header'
import SmallCalendarWeek from './calendar.small.week/calendar.small.week'
let config = {
    template: template,
    data: {
    },
    actions: {},
    beforeRender(){
    },
    afterRender() {
        let _this = this;
        this.append(new SmallCalendarHeader({data:{headList:this.data.headList}}), this.el.find('.calendar-headers'));
        this.data.dayList.forEach(function (val,index) {
            _this.append(new SmallCalendarWeek({data:{dayList:val.weekList}}), _this.el.find('.calendar-main'));
        })
    },
    firstAfterRender() {}
};
let SmallCalendar = Component.extend(config);

export default SmallCalendar;


// WEBPACK FOOTER //
// app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.js